import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import { PlayerModel } from '../../modules/player/model';
import { PlayerController } from '../../modules/player/controller';
import { PlayerBar as Player } from '../player-bar';
import { AddRemoveCompat } from '../compat/add-remove-compat';
import { FavouriteButtonCompat } from '../compat/favourite-button-compat';
import {ArtistSchema, TrackSchema} from '../../types/schema';
import {classes, style} from 'typestyle';
import {zPlayer} from '../../theme/z';
import {colorSlate} from '../../theme/color';
import {constantDrawerWidth, constantPlayerHeight} from '../../theme/constant';
import {centerJustified, horizontal} from 'csstips';
import {transitionQuickEase} from '../../theme/transition';
import {mediaDesktop} from '../../theme/media';
import {important} from 'csx';

export interface PlayerBarProps {
  className?: string;
  visible: boolean;
}

@inject(deps) @observer
export class PlayerBar extends Component<PlayerBarProps> {
  render() {
    const controller: PlayerController = this.props.controller.player;
    const model: PlayerModel = this.props.model.player;
    const { preloadImage, preloadWaveformSvg } = this.props.controller.image;
    const { es6 } = this.props.model.env;
    const { handleClickLink, handleClickSignIn } = this.props.controller.ui;

    // Needed for some weird first render issue
    const props = { AddRemove: AddRemoveCompat, Favourite: FavouriteButtonCompat };

    const className = classes(
      PlayerBar.styles.container,
      this.props.model.ui.showMenuDrawer && PlayerBar.styles.containerShunted,
      !this.props.visible && PlayerBar.styles.hidden
    );

    return (
      <Player
        analytics={this.props.controller.analytics}
        className={className}
        es6={es6}
        model={model.player}
        onChangeVolume={controller.setVolume}
        onClickNext={controller.next}
        onClickPrevious={controller.previous}
        onClickPlay={controller.play}
        onClickPause={controller.pause}
        onFinish={controller.stop}
        onMeta={controller.onMeta}
        preload={preloadImage}
        preloadWaveform={preloadWaveformSvg}
        onClickLink={handleClickLink}
        onClickSignIn={handleClickSignIn}
        loadAudioMeta={this.props.controller.api.audio.loadAudio}
        attachPlayListener={this.props.controller.player.attachPlayListener}
        {...props}
      />
    );
  }

  static styles = {
    container: style({
      ...horizontal,
      ...centerJustified,
      zIndex: zPlayer,
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: colorSlate.toString(),
      height: constantPlayerHeight,
      opacity: 1,
      transition: `transform ${transitionQuickEase}, opacity ${transitionQuickEase}`,
      transform: `translate3d(0,0,0)`
    }),
    containerShunted: style(
      mediaDesktop({
        right: constantDrawerWidth
      })
    ),
    hidden: style({
      transform: important(`translate3d(0, ${constantPlayerHeight}, 0)`),
      opacity: important(0) as any
    })
  }
}
